(function () {
  function pad2(n) {
    return String(Math.max(0, Math.min(99, n))).padStart(2, '0');
  }

  function parseEnd(raw) {
    if (!raw || typeof raw !== 'string') return NaN;
    var t = Date.parse(raw.trim());
    return Number.isFinite(t) ? t : NaN;
  }

  function bind(el) {
    var rawEnd = el.dataset.end;
    if (rawEnd == null || String(rawEnd).trim() === '') {
      el.hidden = true;
      return;
    }
    var endMs = parseEnd(rawEnd);
    if (!Number.isFinite(endMs)) {
      el.hidden = true;
      return;
    }

    var dEl = el.querySelector('[data-promo-countdown-d]');
    var hEl = el.querySelector('[data-promo-countdown-h]');
    var mEl = el.querySelector('[data-promo-countdown-m]');
    var sEl = el.querySelector('[data-promo-countdown-s]');

    function tick() {
      var now = Date.now();
      var remaining = endMs - now;
      if (remaining <= 0) {
        el.hidden = true;
        return;
      }
      var totalSec = Math.floor(remaining / 1000);
      var days = Math.floor(totalSec / (60 * 60 * 24));
      var hours = Math.floor((totalSec % (60 * 60 * 24)) / (60 * 60));
      var mins = Math.floor((totalSec % (60 * 60)) / 60);
      var secs = totalSec % 60;
      if (dEl) dEl.textContent = String(Math.max(0, days));
      if (hEl) hEl.textContent = pad2(hours);
      if (mEl) mEl.textContent = pad2(mins);
      if (sEl) sEl.textContent = pad2(secs);
      el.hidden = false;
    }

    tick();
    setInterval(tick, 1000);
  }

  document.querySelectorAll('[data-promo-countdown], [data-announcement-promo-countdown]').forEach(bind);
})();
